export default "__VITE_ASSET__16a2a0cf__"